import create from "zustand";
export const useStore = create((set, get) => ({
  allWheelSizes: null,
  getWheelSizes: (payload) => {
    let arr = [];
    payload.map((product) => {
      if (product.title) {
        product.tags.map((tag) => {
          if (tag.includes("wheel_size")) {
            arr.push(tag);
          }
        });
      } else {
        if (product[1].length > 1) {
          product[1].map((sub_product) => {
            sub_product.tags.map((tag) => {
              if (tag.includes("wheel_size")) {
                arr.push(tag);
              }
            });
          });
        } else {
          product[1][0].tags.map((tag) => {
            if (tag.includes("wheel_size")) {
              arr.push(tag);
            }
          });
        }
      }
    });
    if (arr.length === 0) arr = null;
    get().allWheelSizes = [...new Set(arr)];
  },
}));
